/**
 * Aviso arriba de la ficha de una tarea descartada: el motivo, quién la descartó y cuándo, y
 * «Reabrir» (vuelve a «Nuevo» y limpia el motivo; queda en el historial). Quién y cuándo salen del
 * último evento de estado que llevó la tarea a «Descartada».
 */
import {
  ETIQUETA_ESTADO,
  textoMotivoDescarte,
  type EventoTarea,
  type Tarea,
} from '@cdtec-backlog/contrato';
import { Icono } from '../../componentes/Icono';
import { fechaHora } from '../../lib/formato';
import { useMoverTarea } from './hooks';
import './AvisoDescartada.css';

interface Props {
  tarea: Tarea;
  eventos?: EventoTarea[];
  puedeEscribir: boolean;
}

export function AvisoDescartada({ tarea, eventos = [], puedeEscribir }: Props) {
  const mover = useMoverTarea();
  if (tarea.estado !== 'DESCARTADA') return null;

  const evento = [...eventos]
    .reverse()
    .find((e) => e.tipo === 'ESTADO' && e.a === ETIQUETA_ESTADO.DESCARTADA);
  const quien = evento?.autor?.nombre;
  const cuando = tarea.cerradaEn ?? evento?.creadoEn;
  const motivo = tarea.descarte ? textoMotivoDescarte(tarea.descarte) : 'Sin motivo registrado.';

  return (
    <div className="aviso-descartada" role="status">
      <Icono nombre="prohibido" tamano={18} />
      <div className="aviso-descartada__texto">
        <p>
          <strong>Descartada</strong> · {motivo}
        </p>
        {(quien || cuando) && (
          <small>{[quien, cuando ? fechaHora(cuando) : null].filter(Boolean).join(' · ')}</small>
        )}
      </div>
      {puedeEscribir && (
        <button
          type="button"
          className="boton"
          disabled={mover.isPending}
          onClick={() => mover.mutate({ id: tarea.id, estado: 'NUEVO' })}
        >
          Reabrir
        </button>
      )}
    </div>
  );
}
